import { render, staticRenderFns } from "./WasteCollectionOrderPreviewModal.vue?vue&type=template&id=2771b33c&scoped=true&"
import script from "./WasteCollectionOrderPreviewModal.vue?vue&type=script&lang=js&"
export * from "./WasteCollectionOrderPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./WasteCollectionOrderPreviewModal.vue?vue&type=style&index=0&id=2771b33c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2771b33c",
  null
  
)

export default component.exports